import React, { useEffect } from "react";
import { QuickTestActivityFormStyled } from "./styled";
import {
  useForm,
  // useFieldArray,
  Controller,
} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// import { IMG_PATH } from "utils/constants/imgPath";
import { Buttons, Inputs } from "components";

// const createQuestionSchema = (question) => {
//   let schema = yup.object().shape({
//     // pdpa_ref_id: Yup.string().required("PDPA reference ID is required"),
//     // question: Yup.string().required("Question text is required"),
//     // type: Yup.number().required("Question type is required"),
//     // img_path: Yup.string().nullable(),
//     // answer_list: Yup.array().of(Yup.string()).nullable(),
//     // answer: yup.string().nullable(),
//     // is_require: yup.boolean().required("Is require is required"),
//   });

//   // ถ้าคำถามเป็น required, เพิ่มการตรวจสอบเพิ่มเติมสำหรับคำตอบ
//   if (question.is_require) {
//     schema = schema.shape({
//       answer: yup.mixed().test("is-string-or-array", "required", (value) => {
//         return (
//           typeof value === "string" ||
//           Array.isArray(value) ||
//           typeof value === "object"
//         );
//       }),
//     });
//   }

//   return schema;
// };

const QuickTestActivityForm = ({
  initialValues,
  // currentPage,
  initialValue,
  // totalPage,
  permission,
  // onBack,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    // questions: yup
    //   .array()
    //   .of(yup.lazy((question) => createQuestionSchema(question)))
    //   .required("Questions are required"),
    // questions: yup.array().of(
    // yup.object().shape({
    //   answer: yup.mixed().test("is-string-or-array", "required", (value) => {
    //     return (
    //       typeof value === "string" ||
    //       Array.isArray(value) ||
    //       typeof value === "object"
    //     );
    //   }),
    // })
    // ),
  });

  const {
    control,
    handleSubmit,
    // watch,
    formState: { errors },
    reset,
    // setError,
  } = useForm({
    resolver: yupResolver(schema),
  });

  // const {
  //   // fields,
  //   // append, remove
  // } = useFieldArray({
  //   control,
  //   name: "questions",
  // });

  useEffect(() => {
    if (initialValue) {
      reset({
        ...initialValue,
      });
    }
  }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps

  // const _handleSubmit = (values) => {
  //   let isErr = false;
  //   if (values.questions && values.questions.length > 0) {
  //     values.questions.forEach((e, i) => {
  //       if (
  //         e.is_require &&
  //         (e.answer === "Other" ||
  //           e.answer === "อื่นๆ" ||
  //           e.answer === "อื่นๆ:") &&
  //         !e.other
  //       ) {
  //         isErr = true;
  //         setError(`questions[${i}].other`, {
  //           type: "custom",
  //           message: "require",
  //         });
  //       }
  //     });
  //     if (!isErr) {
  //       onSubmit(values);
  //     }
  //   }
  // };

  return (
    <QuickTestActivityFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="f_question_layout">
          <div className="question_label">คำถาม</div>
          <div
            className="question_html"
            dangerouslySetInnerHTML={{
              __html: initialValue.question,
            }}
          />
        </div>
        <div className="ans_layout">คำตอบ {initialValue.answer}</div>
        <div className="line_horizontal" />
        <div className="form_layout">
          <div className="input_wrap">
            {initialValue.type === "1" && (
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Radio
                    {...field}
                    options={
                      initialValue.answer_list
                        ? initialValue.answer_list.map((e) => ({
                            label: e.ans || e,
                            value: e.ans || e,
                          }))
                        : []
                    }
                    errors={errors.answer?.message}
                  />
                )}
                name={`answer`}
              />
            )}
            {initialValue.type === "2" && (
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.TextArea {...field} errors={errors.answer?.message} />
                )}
                name={`answer`}
              />
            )}
            {initialValue.type === "3" && (
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.UploadImage
                    theme_upload_image
                    {...field}
                    errors={errors.answer?.message}
                  />
                )}
                name={`answer`}
              />
            )}
            {initialValue.type === "5" && (
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.DateTime
                    theme_upload_image
                    {...field}
                    errors={errors.answer?.message}
                  />
                )}
                name={`answer`}
              />
            )}
          </div>
          {initialValues && permission.is_update ? (
            <>
              <div className="w120">
                <Buttons.BgStandard
                  type="submit"
                  label="Update"
                  // disabled={initialValues && initialValues.is_center}
                />
              </div>
            </>
          ) : (
            permission.is_create && (
              <div className="w120">
                <Buttons.BgStandard
                  type="submit"
                  label="Save"
                  // disabled={initialValues && initialValues.is_center}
                />
              </div>
            )
          )}
        </div>
      </form>
    </QuickTestActivityFormStyled>
  );
};

QuickTestActivityForm.propTypes = {};

export default QuickTestActivityForm;
